const tim = (_this)=>{
	return [{
			text: _this.$t('promote._Hoje'),
			value: 'today'
		},
		{
			text: _this.$t('promote._Ontem'),
			value: 'yesterday'
		},
		{
			text: _this.$t('_homeTile_tab._ltimosDias7'),
			value: "7day"
		},
		{
			text: _this.$t('_homeTile_tab._ltimosDias15'),
			value: '15day'
		},
		{
			text: _this.$t('_homeTile_tab._ltimosDias30'),
			value: '30day'
		},
		{
			text: _this.$t('withdraw._Tudo') ,
			value: 'all',
			is: false
		},
	]
}
const timValue = 'today';



const tim_q = (_this)=>{
	return [{
			text: _this.$t('promote._Hoje'),
			value: '0'
		},
		{
			text: _this.$t('withdraw._Aguardandoapostas'),
			value: '1'
		},
		{
			text: _this.$t('_homeTile_tab._Emandamento'),
			value: "2"
		},
		{
			text: _this.$t('withdraw._Completado'),
			value: '3'
		},
		{
			text: _this.$t('withdraw._Abandonado'),
			value: '4'
		},
	]
}

let domFunCtina = (_this)=>{
	return [{
		text: _this.$t('withdraw._Tudo'),
		value: "all"
	}, {
		text: _this.$t('promote._Hoje'),
		value: "today"
	}, {
		text: _this.$t('promote._EsteMês'),
		value: "yesterday"
	}, {
		text: _this.$t('promote._EstáSemana'),
		value: "week"
	}, {
		text: _this.$t('promote._ÚltimaSemana'),
		value: "last_week"
	}, {
		text: _this.$t('promote._EsteMês'),
		value: "month"
	}, {
		text: _this.$t('_homeTile_tab._ltimosDias2'),
		value: "2month"
	}, {
		text:  _this.$t('_homeTile_tab._ltimosDias3'),
		value: "3month"
	}]
}
let conteNameValue = 'today';

const ContaType = (_this)=>{
	return [{
			text: _this.$t('_homeTile_tab._TodososStatus'),
			value: "0"
		},
		{
			text: _this.$t('_homeTile_tab._NoLiquidado'),
			value: "1"
		},
		{
			text: _this.$t('_homeTile_tab._Liquidado'),
			value: "2"
		},
		{
			text: _this.$t('_homeTile_tab._Pedidocancelado'),
			value: "3"
		},
	]
}

const ContaTypeValue = '0';
// [
// 	{text:"Fundo de\nPrevidência",value:"0"}
// ]
// [	


// ]
const game_type = (_this)=>{
		return [{
			text: _this.$t('_homeTile_tab._TodososTipos'),
			value: "0"
		},
		{
			text: _this.$t('_home._Slots'),
			value: "1"
		},
		{
			text: _this.$t('_home._Pescaria'),
			value: "2"
		},
	]
}
const game_typeValue = '0'

const Conta_Type =(_this)=>{
	return [
		{text: _this.$t('_homeTile_tab._TodososTipos'),value:"1"},{text:_this.$t('_homeTile_tab._TrocadeFundos'),value:"2"},{text:_this.$t('_homeTile_tab._RecargadeMembro'),value:"3"},{text:_this.$t('_homeTile_tab._SaquedeMembro'),value:"4"},{text:_this.$t('_homeTile_tab._LiquidaodoComerciante'),value:"5"},{text:_this.$t('_homeTile_tab._CorreodeFundo'),value:"6"},
	]
} 

const Conta_TypeValue = '1';
const timValue_q = '0';
const records= (_this)=>{
	return [{
			text: _this.$t('promote._Hoje'),
			value: "0"
		}, {
			text: _this.$t('promote._Ontem') ,
			value: "1"
		}, {
			text: _this.$t('_homeTile_tab._ltimosDias7'),
			value: "2"
		},
		{
			text: _this.$t('_homeTile_tab._ltimosDias15'),
			value: "3"
		}, {
			text: _this.$t('_homeTile_tab._ltimosDias30'),
			value: "4"
		}, {
			text:  _this.$t('_homeTile_tab._Quasedias60'),
			value: "5"
		}
	]
}
const recordsTudo=(_this)=>{
	return [
		{text:_this.$t('withdraw._Tudo'),value:"0"},{text:_this.$t('components._Resgatado'),value:"1"},{text:_this.$t('_homeTile_tab._Distribudo'),value:"2"}
	]
}
export {
	tim,
	timValue,
	timValue_q,
	tim_q,
	ContaType,
	ContaTypeValue,
	game_type,
	game_typeValue,
	Conta_Type,
	Conta_TypeValue,
	domFunCtina,
	records,
	recordsTudo,
	conteNameValue,
}



